import { AlphaOnlyDirective } from './directive/alpha-only.directive';
import { NumberOnlyDirective } from './directive/number-only.directive';
import { NbpInfoComponent } from './modal/nbp-info.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { KzMaskDirective } from './kz-mask.directive';
import { NbpConfirmComponent } from './modal/nbp-confirm.component';
import { NgbdModalContent } from './modal/ngbd-modal-content';
import { CpfPipe, CnpjPipe, TelefonePipe, CepPipe } from './pipes/filters-br.pipe';
import { CarouselDirective } from './carousel.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NbpModalImagemComponent } from './modal/nbp-modal-imagem.component';
import { NbpOnlyConfirmComponent } from './modal/nbp-only-confirm.component';
import { UppercaseDirective } from './directive/uppercase.directive';

export const importExportItens = [
  NbpConfirmComponent,
  NbpInfoComponent,
  KzMaskDirective,
  CarouselDirective,
  NbpConfirmComponent,
  NgbdModalContent,
  CpfPipe,
  CnpjPipe,
  TelefonePipe,
  CepPipe,
  NumberOnlyDirective,
  AlphaOnlyDirective,
  UppercaseDirective,
  NbpModalImagemComponent,
  NbpOnlyConfirmComponent
];

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  exports: [
    importExportItens
  ],
  declarations: [
    importExportItens
  ],
  entryComponents: [NgbdModalContent, NbpConfirmComponent, NbpInfoComponent, NbpModalImagemComponent, NbpOnlyConfirmComponent]
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts